import ListaFichajesImpl from 'components/fichajes/ListaFichajesImpl'
import React from 'react'
import { Col, Row } from 'reactstrap'

const ViewListEmpleadoFichajes = () => {
  return (
    <>
        <Row>
            <Col>
                <ListaFichajesImpl></ListaFichajesImpl>
            </Col>
        </Row>
    </>
  )
}

export default ViewListEmpleadoFichajes